import React from 'react';
import ReactMarkdown from 'react-markdown';

const EducationItem = (x) => (
  <div key={x.id} className="mb-3 education-item">
    <h6 className="font-semibold">{x.key}</h6>
    <p className="text-xs">{x.major}</p>
    <ReactMarkdown className="mt-2 text-sm" source={x.description.replace(/\n/gi, '\n\n')} />
  </div>
);

const Education = ({ data }) => {
  return data.education && data.education.enable ? (
    <div className="mb-6">
      <div className="mb-1 mt-3 font-bold tracking-wide" style={{ fontSize: 14 }}>
        {data.education.heading}
      </div>
      {data.education.items.filter((x) => x.enable).map(EducationItem)}
    </div>
  ) : null;
};

export default Education;
